import { render, staticRenderFns } from "./CTitle.vue?vue&type=template&id=69ced1b6&scoped=true&"
import script from "./CTitle.vue?vue&type=script&lang=js&"
export * from "./CTitle.vue?vue&type=script&lang=js&"
import style0 from "./CTitle.vue?vue&type=style&index=0&id=69ced1b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ced1b6",
  null
  
)

export default component.exports